/**
 * Minnelea — Premium Scroll Animations
 * Refined, editorial-grade motion for food luxury brand.
 *
 * 1. Scroll Reveal: fade + slide-up, with staggered children
 * 2. Hero Text: words appear one by one, slow and elegant
 * 3. Counter: animated number counting for awards/stats
 * 4. Parallax: subtle depth on background images
 *
 * Respects prefers-reduced-motion. Disabled on mobile for parallax.
 */
(function () {
  'use strict';

  var MOBILE = 750;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ═══════════════════════════════════════════
     SCROLL REVEAL — fade + slide-up
     ═══════════════════════════════════════════ */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;

    els.forEach(function (el) {
      if (reducedMotion) { el.style.opacity = '1'; return; }
      el.style.opacity = '0';
      el.style.transform = 'translateY(32px)';
      el.style.transition = 'none';
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseFloat(el.getAttribute('data-reveal-delay') || '0');

        // Force reflow so transition kicks in
        void el.offsetHeight;
        el.style.transition = 'opacity 0.9s cubic-bezier(0.22,1,0.36,1), transform 0.9s cubic-bezier(0.22,1,0.36,1)';
        el.style.transitionDelay = delay + 's';

        requestAnimationFrame(function () {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        });

        observer.unobserve(el);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ═══════════════════════════════════════════
     STAGGERED REVEAL — children appear one by one
     Parent: data-stagger  Children: data-stagger-child
     ═══════════════════════════════════════════ */
  function initStagger() {
    var groups = document.querySelectorAll('[data-stagger]');
    if (!groups.length) return;

    groups.forEach(function (group) {
      var children = group.querySelectorAll('[data-stagger-child]');
      var baseDelay = parseFloat(group.getAttribute('data-stagger-base') || '0');
      var step = parseFloat(group.getAttribute('data-stagger-step') || '0.12');

      children.forEach(function (child, i) {
        if (reducedMotion) { child.style.opacity = '1'; return; }
        child.style.opacity = '0';
        child.style.transform = 'translateY(24px)';
        child.style.transition = 'none';
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          children.forEach(function (child, i) {
            var d = baseDelay + (i * step);
            void child.offsetHeight;
            child.style.transition = 'opacity 0.7s cubic-bezier(0.22,1,0.36,1), transform 0.7s cubic-bezier(0.22,1,0.36,1)';
            child.style.transitionDelay = d + 's';
            requestAnimationFrame(function () {
              child.style.opacity = '1';
              child.style.transform = 'translateY(0)';
            });
          });

          observer.unobserve(entry.target);
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

      observer.observe(group);
    });
  }

  /* ═══════════════════════════════════════════
     HERO TEXT — words fade in one by one
     Element: data-hero-words
     ═══════════════════════════════════════════ */
  function initHeroWords() {
    var el = document.querySelector('[data-hero-words]');
    if (!el || reducedMotion) return;

    var text = el.textContent.trim();
    var words = text.split(/\s+/);
    el.innerHTML = '';
    el.style.opacity = '1';

    words.forEach(function (word, i) {
      var span = document.createElement('span');
      span.textContent = word;
      span.style.cssText = 'display:inline-block;opacity:0;transform:translateY(12px);transition:opacity 0.6s cubic-bezier(0.22,1,0.36,1),transform 0.6s cubic-bezier(0.22,1,0.36,1);transition-delay:' + (0.3 + i * 0.09) + 's';
      el.appendChild(span);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var spans = el.querySelectorAll('span');
        spans.forEach(function (s) {
          s.style.opacity = '1';
          s.style.transform = 'translateY(0)';
        });
        observer.unobserve(el);
      });
    }, { threshold: 0.3 });

    observer.observe(el);
  }

  /* ═══════════════════════════════════════════
     HERO ENTRANCE — label, subtitle, text, ctas, trust
     Cascaded fade-in after the title words
     ═══════════════════════════════════════════ */
  function initHeroEntrance() {
    var hero = document.querySelector('.mn-hero');
    if (!hero || reducedMotion) return;

    var elements = [
      { sel: '.mn-hero__label', delay: 0 },
      { sel: '.mn-hero__subtitle', delay: 0.8 },
      { sel: '.mn-hero__text', delay: 0.95 },
      { sel: '.mn-hero__ctas', delay: 1.1 },
      { sel: '.mn-hero__trust', delay: 1.3 }
    ];

    elements.forEach(function (item) {
      var el = hero.querySelector(item.sel);
      if (!el) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 0.8s cubic-bezier(0.22,1,0.36,1), transform 0.8s cubic-bezier(0.22,1,0.36,1)';
      el.style.transitionDelay = item.delay + 's';

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        });
      });
    });
  }

  /* ═══════════════════════════════════════════
     COUNTER — animate numbers up
     Element: data-counter="125"
     ═══════════════════════════════════════════ */
  function initCounters() {
    var counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;

    counters.forEach(function (el) {
      if (reducedMotion) return;
      var target = parseInt(el.getAttribute('data-counter'), 10);
      var suffix = el.getAttribute('data-counter-suffix') || '';
      var prefix = el.getAttribute('data-counter-prefix') || '';
      el.textContent = prefix + '0' + suffix;
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-counter'), 10);
        var suffix = el.getAttribute('data-counter-suffix') || '';
        var prefix = el.getAttribute('data-counter-prefix') || '';
        var duration = 1800;
        var start = performance.now();

        function ease(t) {
          // ease-out expo
          return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
        }

        function step(now) {
          var t = Math.min((now - start) / duration, 1);
          var val = Math.round(ease(t) * target);
          el.textContent = prefix + val + suffix;
          if (t < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
        observer.unobserve(el);
      });
    }, { threshold: 0.5 });

    counters.forEach(function (el) { observer.observe(el); });
  }

  /* ═══════════════════════════════════════════
     PARALLAX — subtle depth on images
     ═══════════════════════════════════════════ */
  var pxItems = [];
  var ticking = false;

  function initParallax() {
    if (window.innerWidth < MOBILE || reducedMotion) return;
    document.querySelectorAll('[data-parallax]').forEach(function (el) {
      pxItems.push({
        el: el,
        speed: parseFloat(el.getAttribute('data-parallax-speed') || '0.15'),
        dir: el.getAttribute('data-parallax-dir') || 'up'
      });
    });
    if (pxItems.length) {
      window.addEventListener('scroll', onScroll, { passive: true });
      updateParallax();
    }
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(tickPx); }
  }

  function tickPx() {
    updateParallax();
    ticking = false;
  }

  function updateParallax() {
    var winH = window.innerHeight;
    for (var i = 0; i < pxItems.length; i++) {
      var item = pxItems[i];
      var rect = item.el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > winH + 200) continue;
      var center = rect.top + rect.height / 2;
      var offset = (center - winH / 2) * item.speed;
      if (item.dir === 'down') offset = -offset;
      item.el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
    }
  }

  /* ═══════════════════════════════════════════
     INIT
     ═══════════════════════════════════════════ */
  function init() {
    initReveal();
    initStagger();
    initHeroWords();
    initHeroEntrance();
    initCounters();
    initParallax();
  }

  // Resize handler
  var wasMobile = window.innerWidth < MOBILE;
  window.addEventListener('resize', function () {
    var isMobile = window.innerWidth < MOBILE;
    if (isMobile && !wasMobile) {
      pxItems.forEach(function (item) { item.el.style.transform = ''; });
      pxItems = [];
      window.removeEventListener('scroll', onScroll);
    } else if (!isMobile && wasMobile && !pxItems.length) {
      initParallax();
    }
    wasMobile = isMobile;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
